module.exports = {
  AutoIdProvider: require('./lib/AutoIdProvider').default,
  useId: require('./lib/useId').default,
};
